import { Injectable } from "@angular/core";
import { APIENDPOINTS } from "../../common/constants";
import { AppConfigService, KnownConfigKey } from "src/app/services/app.config.service";
@Injectable({
  providedIn: "root",
})
export class ConfigService {
  gatewayBaseUrl: string = undefined;
  shapeFileLocation: string="";
  mapUrl: string="";
  constructor(private appConfig: AppConfigService) {
    this.gatewayBaseUrl = this.appConfig.getSetting<string>(KnownConfigKey.gatewayUrl);
    this.mapUrl = this.appConfig.getSetting<string>(KnownConfigKey.spatialMapUrl);
    this.shapeFileLocation = this.appConfig.getSetting<string>(KnownConfigKey.spatialFileUploadLocation);
  }

  formatUrl(endpoint: string): string {
    return `${this.gatewayBaseUrl}${endpoint}`;
  }

  get WantedCreditsUrl() {
    return this.formatUrl(APIENDPOINTS.WantedCredits);
  }

  get LookupUrl() {
    return this.formatUrl(APIENDPOINTS.Lookup);
  }

  get ClassificationsUrl() {
    return this.formatUrl(APIENDPOINTS.Classifications_Lookup);
  }

  get TradingGroupsUrl() {
    return this.formatUrl(APIENDPOINTS.TradingGroups);
  }

  get ProgramsUrl(): string {
    return this.formatUrl(APIENDPOINTS.CreditPrograms);
  }

  get ActieProgramsUrl(): string {
    return this.formatUrl(APIENDPOINTS.ActivePrograms);
  }

  get OfferUrl() {
    return this.formatUrl(APIENDPOINTS.CreditOffer);
  }

  get OfferFileUrl() {
    //no need to use the gateway to upload file as this is handled with in the file controller
    // in this project
    return this.formatUrl(APIENDPOINTS.FileUpload);
  }

  get GetUserUrl() {
    return this.formatUrl(`${APIENDPOINTS.UserBaseUrl}/`);
  }

  get AddUserUrl() {
    return this.formatUrl(APIENDPOINTS.UserBaseUrl);
  }

  updateUserProfileUrl(userKey: string) {
    return this.formatUrl(`${APIENDPOINTS.UserBaseUrl}/${userKey}/contact`);
  }

  get PrepareOfferUrl() {
    return this.formatUrl(APIENDPOINTS.PrepareOffer);
  }

  get RegisterTooltipUrl() {
    return this.formatUrl(APIENDPOINTS.RegisterTooltip);
  }

  get QuoteApplicationUrl() {
    return this.formatUrl(APIENDPOINTS.QUOTE_APPLICATION);
  }

  get QuoteApplicationGetByIdUrl() {
    return this.formatUrl(APIENDPOINTS.GET_QUOTE_APPLICATION);
  }

  get QuoteSubmitUrl() {
    return this.formatUrl(APIENDPOINTS.SUBMIT_QUOTE_APPLICATION);
  }

  get QuoteUpdateUrl() {
    return this.formatUrl(APIENDPOINTS.UPDATE_QUOTE_APPLICATION);
  }

  get QuoteDeleteUrl() {
    return this.formatUrl(APIENDPOINTS.QUOTE_APPLICATION);
  }

  get QuoteCreditAddUrl() {
    return this.formatUrl(APIENDPOINTS.ADD_QUOTE_CREDIT);
  }

  get QuoteCreditUpdateUrl() {
    return this.formatUrl(APIENDPOINTS.UPDATE_QUOTE_CREDIT);
  }

  get QuoteCreditDeleteUrl() {
    return this.formatUrl(APIENDPOINTS.DELETE_QUOTE_CREDIT);
  }

  get updateContactUrl(): String {
    return this.formatUrl(APIENDPOINTS.UPDATE_APPLICANT_CONTACT);
  }

  get updateApplicantDetailUrl(): String {
    return this.formatUrl(APIENDPOINTS.UPDATE_APPLICANT_DETAILS);
  }

  get applicantDetailUrl(): String {
    return this.formatUrl(APIENDPOINTS.GET_APPLICANT_DETAILS);
  }

  get quoteObligationUrl():String{
    return this.formatUrl(APIENDPOINTS.QUOTE_OBLIGATION_URL);
  }

  get obligationPaymentCertificateMailSentUrl(): string {
    return this.formatUrl(APIENDPOINTS.OBLIGATION_PAYMENT_CERTIFICATE_MAIL_SENT);
  }

  get enableOffsetPayments(): boolean {
    return this.appConfig.getSetting<boolean>(KnownConfigKey.enableOffsetPayments);
  }

  get enableCreditOffers(): boolean {
    return this.appConfig.getSetting<boolean>(KnownConfigKey.enableCreditOffers) === true;
  }

  get maintenanceMode(): boolean {
    return this.appConfig.getSetting<boolean>(KnownConfigKey.maintenanceMode) === true;
  }

  get maintenanceMessage(): string {
    return this.appConfig.getSetting<string>(KnownConfigKey.maintenanceMessage)?.trim() ||
      "Offset payments in the BCF Credit Portal are currently offline for server maintenance. Applications for quotes and payments into the Biodiversity Conservation Fund are temporarily on hold during this time.";
  }

  get maintenanceRetryMessage(): string {
    return this.appConfig.getSetting<string>(KnownConfigKey.maintenanceRetryMessage)?.trim() || "";
  }

  get obligationPaymentObligationsUrl(): string {
    return this.formatUrl(APIENDPOINTS.OBLIGATION_PAYMENT_OBLIGATIONS);
  }
}
